import { Promotion, PromotionInProgress, PromotionResponse, PromotionScheduled } from '@playq/octopus-common';

export const isPromotionLoading = (promotion?: PromotionResponse | Promotion): boolean => {
  return promotion
    ? promotion.state instanceof PromotionInProgress || promotion.state instanceof PromotionScheduled
    : false;
};
